import { render, staticRenderFns } from "./PXQuestionOverviewPage.vue?vue&type=template&id=7fad85c2&scoped=true"
import script from "./PXQuestionOverviewPage.vue?vue&type=script&lang=js"
export * from "./PXQuestionOverviewPage.vue?vue&type=script&lang=js"
import style0 from "./PXQuestionOverviewPage.vue?vue&type=style&index=0&id=7fad85c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fad85c2",
  null
  
)

export default component.exports